import { z } from 'zod';
import { requiredString } from '../helpers';
export const Cal_Dotcom_Create_Meeting_1_ConfigValidator = z.object({
    calConnection: requiredString('Cal.com Connection is required'),
    startTime: requiredString('Start time is required'),
    attendeeName: requiredString('Attendee name is required'),
    attendeeEmail: requiredString('Attendee email is required'),
    attendeeTimezone: z.string().optional(),
    bookingFieldsResponses: z.record(z.string(), z.string().optional()).optional()
});
//# sourceMappingURL=cal-dotcom-create-meeting-1.js.map